<mat-sidenav-container autosize #drawerContainer class="main-sidenav-container">
  <mat-sidenav
    #sideMenu
    mode="side"
    [opened]="openMenu && !isRestrictedPage && !isServerUnreachableError"
    [disableClose]="true"
    position="start"
    class="main-sidenav"
    [ngClass]="sideMenuService.sidemenuExpanded ? 'expanded' : 'collapsed'"
  >
    @if (isAuthenticated && !isRestrictedPage) {
      <app-side-menu-content #sideMenuContent></app-side-menu-content>
    }
  </mat-sidenav>
  <mat-sidenav-content class="main-content-container">
    <app-responsive-breakpoints></app-responsive-breakpoints>
    @if (!isRestrictedPage && isAuthenticated) {
      <app-top-navbar-content class="main-navbar-container" [ngClass]="!isAuthenticated ? 'no-auth' : ''"></app-top-navbar-content>
    }
    @if (isAuthenticated && bannerSettings && bannerSettings.isBannerVisible) {
      <div
        class="toolbar-banner-container"
        [ngStyle]="{
          'background-color': bannerSettings && bannerSettings.bannerBackgroundColor ? bannerSettings.bannerBackgroundColor : '',
        }"
      >
        <span
          [ngStyle]="{
            color: bannerSettings && bannerSettings.bannerFontColor ? bannerSettings.bannerFontColor : '',
          }"
          >{{ bannerSettings?.bannerIntro }}
          <a
            [href]="bannerSettings.bannerLink"
            [ngStyle]="{
              color: bannerSettings && bannerSettings.bannerLinkColor ? bannerSettings.bannerLinkColor : '',
            }"
            >{{ bannerSettings?.bannerLinkText }}</a
          >
          {{ bannerSettings?.bannerOutro }}
        </span>
      </div>
    }
    <div
      class="main-content-outer"
      [ngClass]="[!isAuthenticated ? 'no-auth' : '', bannerSettings && bannerSettings.isBannerVisible ? 'banner' : '']"
    >
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
@if (isServerUnreachableError) {
  <div id="server-error-blurred-overlay">
    <div class="error-container">
      <img [src]="Environment.serverUnreachable" [alt]="'accessibility_alt_app_servere_unreachable' | translate" class="error-icon" />
      <p>Service is restarting, please wait...</p>
      <p>This page is reloaded automatically when restart is complete.</p>
    </div>
  </div>
}
@if (isAuthenticated && !isServerUnreachableError) {
  <router-outlet #configurationOutlet="outlet" name="configurationOutlet"></router-outlet>
}
@if (isAuthenticated && !isServerUnreachableError) {
  <router-outlet #usecasesOutlet="outlet" name="usecasesOutlet"></router-outlet>
}

@if (imageObject) {
  <ng-image-fullscreen-view
    [images]="imageObject"
    [imageIndex]="0"
    [show]="showPreview"
    (lightboxClose)="closeEventHandler()"
  ></ng-image-fullscreen-view>
}

<tour-step-template />
